import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RecalculateMemberPointPageRoutingModule } from './recalculate-member-point-routing.module';

import { RecalculateMemberPointPage } from './recalculate-member-point.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RecalculateMemberPointPageRoutingModule
  ],
  declarations: [RecalculateMemberPointPage]
})
export class RecalculateMemberPointPageModule {}
